module.exports = __webpack_public_path__ + "static/media/icon-offer-longtime.55ee1293.svg";